<script>
export default {
  name: 'ui-chevron-left-icon',
}
</script>

<template>
  <svg width="15" height="24" viewBox="0 0 15 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M13 2L3 12L13 22" stroke="currentColor" stroke-width="3" />
  </svg>
</template>



// WEBPACK FOOTER //
// src/templates/pages/events/components/icons/chevron-left.vue